import { useContext } from "react";

const { createContext, useState } = require("react");

const CommonContext = createContext();

/*
* 데이터 유지를 위해 필요
*/
export const CommonProvider = ({ children }) => {

  const [sharedData, setSharedData] = useState({
    category: {}
  });

  const updateSharedData = ({key, newData}) => {
    setSharedData({ ...sharedData, [key]: {...newData} });
  };

  return (
    <CommonContext.Provider value={{ sharedData, updateSharedData }}>
      {children}
    </CommonContext.Provider>
  )
}

export const useCommonContext = () => { 
  return useContext(CommonContext);
}